module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flickr3",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "flickr3"
    }
  }, [_c('h3', [_vm._v("Photos from " + _vm._s(_vm.store.state.currentNeighborhood))]), _vm._v(" "), _vm._l((_vm.flickrPhotos3.slice(0, 20)), function(url) {
    return _c('span', [_c('a', {
      attrs: {
        "href": url
      }
    }, [_c('img', {
      staticClass: "preview_photo",
      attrs: {
        "src": url
      }
    })])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-194cb424!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flickr3.vue
// module id = 174
// module chunks = 1